import baseScmService from 'services/baseScmService';

const creditManagementService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    addCreditPoints: build.mutation({
      query: (addCreditObject) => ({
        method: 'POST',
        url: `/ledger-transactions`,
        body: addCreditObject,
      }),
    }),
  }),
});

export const { useAddCreditPointsMutation } = creditManagementService;

export default creditManagementService;
